import { DragEvent, useState } from 'react';

const moveItem = <T>(items: T[], from: T, to: T): T[] => {
  const toIdx = items.findIndex((s) => s === to);
  const reorderedItems = items.filter((s) => s !== from);
  reorderedItems.splice(toIdx, 0, from);
  return reorderedItems;
};

export const useDraggableList = <T>(list: T[], onDrop: (reorderedList: T[]) => void) => {
  const [reorderedList, setReorderedList] = useState<T[] | null>(null);
  const [draggedItem, setDraggedItem] = useState<T | null>(null);

  return {
    reorderedList,
    draggedItem,
    draggableAttributes: (section: T) => ({
      draggable: true,
      onDragStart: (event: DragEvent) => {
        event.dataTransfer.dropEffect = 'move';
        setReorderedList(list);
        setDraggedItem(section);
      },
      onDragEnter: (event: DragEvent) => {
        event.preventDefault();
        if (section === draggedItem) {
          return;
        }

        setReorderedList(moveItem(reorderedList as T[], draggedItem as T, section));
      },
      onDragOver: (event: DragEvent) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
      },
      onDragLeave: () => {},
      onDragEnd: () => {
        setReorderedList(null);
        setDraggedItem(null);
      },
      onDrop: (event: DragEvent) => {
        event.preventDefault();
        onDrop(reorderedList as T[]);
      },
    }),
  };
};
